var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { colors } from "@wrstudios/theme";
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-top: auto;\n  padding: 1.2rem;\n  border-top: 0.1rem solid ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  margin-top: auto;\n  padding: 1.2rem;\n  border-top: 0.1rem solid ", ";\n"])), colors.gray[500]);
var templateObject_1;